// Actions
export const API_RESPONSE_SUCCESS = 'API_RESPONSE_SUCCESS';
export const API_RESPONSE_ERROR = 'API_RESPONSE_ERROR';
export const GET_FILES = 'GET_FILES';
export const DELETE_FILES = 'DELETE_FILES';
export const DOWNLOAD_FILES = 'DOWNLOAD_FILES';
